import "./Diamond.scss";
import { useId } from "react";
import { Handle, Position } from 'reactflow';
import { NodeContent, NodeInputProps, VerticalFillDefinition } from "./common";

function Diamond(props: NodeInputProps) {
    const id = useId();
    const verticalFillId = `vertical-fill-${id}`;
    const fillPercentage = props.data?.fillPercentage;
    const fill = fillPercentage !== undefined && fillPercentage !== null ? `url("#${verticalFillId}")` : null;

    return (
        <div className="FlowChart-node FlowChart-node-diamond">
            <Handle type="source" id="source-top" position={Position.Top} />
            <Handle type="source" id="source-left" position={Position.Left} />
            <Handle type="source" id="source-bottom" position={Position.Bottom} />
            <Handle type="source" id="source-right" position={Position.Right} />

            <Handle type="target" id="target-top" position={Position.Top} />
            <Handle type="target" id="target-left" position={Position.Left} />
            <Handle type="target" id="target-bottom" position={Position.Bottom} />
            <Handle type="target" id="target-right" position={Position.Right} />

            <svg className="node-shape" viewBox="0 0 100 100" preserveAspectRatio="none" width="100%">
                <defs>
                    <VerticalFillDefinition fillPercentage={fillPercentage} id={verticalFillId} />
                </defs>
                <path d="M1,50 L50,1 L99,50 L50,99 Z" strokeWidth="2" style={{ fill, stroke: fill }}></path>
            </svg>

            <div className="node-content">
                <NodeContent {...props} />
            </div>
        </div>
    );
}

export { Diamond };